import $ from 'jquery';
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';


const marker_types = {
  'restaurants': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.6667 5.50065V12.834H17.4167V20.1673H19.25V1.83398C16.72 1.83398 14.6667 3.88732 14.6667 5.50065ZM10.0833 8.25065H8.25V1.83398H6.41667V8.25065H4.58333V1.83398H2.75V8.25065C2.75 10.2765 4.39083 11.9173 6.41667 11.9173V20.1673H8.25V11.9173C10.2758 11.9173 11.9167 10.2765 11.9167 8.25065V1.83398H10.0833V8.25065Z" fill="white"/></svg>',
  'local-business': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6.41667V2.75H1.83337V19.25H20.1667V6.41667H11ZM5.50004 17.4167H3.66671V15.5833H5.50004V17.4167ZM5.50004 13.75H3.66671V11.9167H5.50004V13.75ZM5.50004 10.0833H3.66671V8.25H5.50004V10.0833ZM5.50004 6.41667H3.66671V4.58333H5.50004V6.41667ZM9.16671 17.4167H7.33337V15.5833H9.16671V17.4167ZM9.16671 13.75H7.33337V11.9167H9.16671V13.75ZM9.16671 10.0833H7.33337V8.25H9.16671V10.0833ZM9.16671 6.41667H7.33337V4.58333H9.16671V6.41667ZM18.3334 17.4167H11V15.5833H12.8334V13.75H11V11.9167H12.8334V10.0833H11V8.25H18.3334V17.4167ZM16.5 10.0833H14.6667V11.9167H16.5V10.0833ZM16.5 13.75H14.6667V15.5833H16.5V13.75Z" fill="white"/></svg>',
  'showhome': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5.67482L15.5834 9.79982V16.959H13.75V11.459H8.25004V16.959H6.41671V9.79982L11 5.67482ZM11 3.20898L1.83337 11.459H4.58337V18.7923H10.0834V13.2923H11.9167V18.7923H17.4167V11.459H20.1667L11 3.20898Z" fill="white"/></svg>',
  'parks': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5374 11.0007H17.3708L10.9541 1.83398L4.58328 11.0007H6.37078L2.79578 16.5007H9.13911V20.1673H12.7599V16.5007H19.2041L15.5374 11.0007ZM6.17828 14.6673L9.75328 9.16732H8.09411L10.9633 5.04232L13.8508 9.16732H12.1091L15.7758 14.6673H6.17828Z" fill="white"/></svg>',
  'recreation': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5374 11.0007H17.3708L10.9541 1.83398L4.58328 11.0007H6.37078L2.79578 16.5007H9.13911V20.1673H12.7599V16.5007H19.2041L15.5374 11.0007ZM6.17828 14.6673L9.75328 9.16732H8.09411L10.9633 5.04232L13.8508 9.16732H12.1091L15.7758 14.6673H6.17828Z" fill="white"/></svg>',
  'schools': '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2.75L0.916626 8.25L4.58329 10.2483V15.7483L11 19.25L17.4166 15.7483V10.2483L19.25 9.24917V15.5833H21.0833V8.25L11 2.75ZM17.2516 8.25L11 11.66L4.74829 8.25L11 4.84L17.2516 8.25ZM15.5833 14.6575L11 17.16L6.41663 14.6575V11.2475L11 13.75L15.5833 11.2475V14.6575Z" fill="white"/></svg>',
  'shopping-centre': `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5849_1063)">
<path d="M10.0832 8.24935H11.9165V5.49935H14.6665V3.66602H11.9165V0.916016H10.0832V3.66602H7.33317V5.49935H10.0832V8.24935ZM6.4165 16.4993C5.40817 16.4993 4.59234 17.3244 4.59234 18.3327C4.59234 19.341 5.40817 20.166 6.4165 20.166C7.42484 20.166 8.24984 19.341 8.24984 18.3327C8.24984 17.3244 7.42484 16.4993 6.4165 16.4993ZM15.5832 16.4993C14.5748 16.4993 13.759 17.3244 13.759 18.3327C13.759 19.341 14.5748 20.166 15.5832 20.166C16.5915 20.166 17.4165 19.341 17.4165 18.3327C17.4165 17.3244 16.5915 16.4993 15.5832 16.4993ZM6.57234 13.5202L6.59984 13.4102L7.42484 11.916H14.254C14.9415 11.916 15.5465 11.5402 15.8582 10.9718L19.3965 4.54602L17.8015 3.66602H17.7923L16.784 5.49935L14.254 10.0827H7.819L7.69984 9.83518L5.6465 5.49935L4.77567 3.66602L3.914 1.83268H0.916504V3.66602H2.74984L6.04984 10.6235L4.81234 12.8693C4.66567 13.126 4.58317 13.4285 4.58317 13.7493C4.58317 14.7577 5.40817 15.5827 6.4165 15.5827H17.4165V13.7493H6.8015C6.68234 13.7493 6.57234 13.6485 6.57234 13.5202Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_5849_1063">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>`,
  'grocery': `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6668 20.1673C13.1391 20.1673 11.8404 19.6326 10.771 18.5632C9.70155 17.4937 9.16683 16.1951 9.16683 14.6673C9.16683 13.1395 9.70155 11.8409 10.771 10.7715C11.8404 9.70204 13.1391 9.16732 14.6668 9.16732C16.1946 9.16732 17.4932 9.70204 18.5627 10.7715C19.6321 11.8409 20.1668 13.1395 20.1668 14.6673C20.1668 16.1951 19.6321 17.4937 18.5627 18.5632C17.4932 19.6326 16.1946 20.1673 14.6668 20.1673ZM14.6668 18.334C15.6752 18.334 16.5384 17.975 17.2564 17.2569C17.9745 16.5388 18.3335 15.6757 18.3335 14.6673C18.3335 13.659 17.9745 12.7958 17.2564 12.0777C16.5384 11.3597 15.6752 11.0007 14.6668 11.0007C13.6585 11.0007 12.7953 11.3597 12.0772 12.0777C11.3592 12.7958 11.0002 13.659 11.0002 14.6673C11.0002 15.6757 11.3592 16.5388 12.0772 17.2569C12.7953 17.975 13.6585 18.334 14.6668 18.334ZM3.66683 18.334C3.16266 18.334 2.73107 18.1545 2.37204 17.7954C2.01301 17.4364 1.8335 17.0048 1.8335 16.5007V9.53398C1.8335 9.41176 1.84495 9.28954 1.86787 9.16732C1.89079 9.0451 1.92516 8.92287 1.971 8.80065L3.80433 4.58398H3.66683C3.40711 4.58398 3.1894 4.49614 3.0137 4.32044C2.83801 4.14475 2.75016 3.92704 2.75016 3.66732V2.75065C2.75016 2.49093 2.83801 2.27322 3.0137 2.09753C3.1894 1.92183 3.40711 1.83398 3.66683 1.83398H10.0835C10.3432 1.83398 10.5609 1.92183 10.7366 2.09753C10.9123 2.27322 11.0002 2.49093 11.0002 2.75065V3.66732C11.0002 3.92704 10.9123 4.14475 10.7366 4.32044C10.5609 4.49614 10.3432 4.58398 10.0835 4.58398H9.946L11.4585 8.06732C11.1682 8.2201 10.8932 8.38051 10.6335 8.54857C10.3738 8.71662 10.1293 8.9076 9.90016 9.12148L7.97516 4.58398H5.77516L3.66683 9.53398V16.5007H7.56266C7.63905 16.8215 7.74218 17.1385 7.87204 17.4517C8.0019 17.7649 8.1585 18.059 8.34183 18.334H3.66683ZM14.6668 8.25065C14.0252 8.25065 13.4828 8.02912 13.0397 7.58607C12.5967 7.14301 12.3752 6.60065 12.3752 5.95898C12.3752 5.31732 12.5967 4.77496 13.0397 4.3319C13.4828 3.88885 14.0252 3.66732 14.6668 3.66732V8.25065C14.6668 7.60898 14.8884 7.06662 15.3314 6.62357C15.7745 6.18051 16.3168 5.95898 16.9585 5.95898C17.6002 5.95898 18.1425 6.18051 18.5856 6.62357C19.0286 7.06662 19.2502 7.60898 19.2502 8.25065H14.6668Z" fill="white"/>
</svg>`,
};

function renderCommunityMapInstance(containerId, mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, proximityMarkerColor, markers, communityLong, communityLat, mapboxUser, mapboxTrailsDatasetID, mapboxTrailsDatasetKey, mapboxToken, options = {}) {
  const { navigationControl = false, popupCloseButton = false } = options;

  if (!$( `#${containerId}` ).length) return;

  const map = new mapboxgl.Map({
    container: containerId,
    style: mapboxStyleURL,
    center: communityMarker,
    zoom: 13,
    maxZoom: 22,
    cooperativeGestures: true,
  });

  if (navigationControl) {
    map.addControl(new mapboxgl.NavigationControl());
  }

  const el = document.createElement('div');
  el.className = 'community-marker';

  new mapboxgl.Marker(el)
    .setLngLat(communityMarker)
    .addTo(map);

  if (containerId !== 'interactive-map') {

    const popup = new mapboxgl.Popup({
      closeOnClick: false,
      anchor: 'top',
      offset: [0, 24],
      closeButton: popupCloseButton,
      noTip: true,
    })
      .setLngLat(communityMarker)
      .setHTML(`<div class="community-thumbnail image-container"><img src="${mapThumbnail}" alt="community thumbnail"></div><div class="community-content"><p class="community-title headline-5">${communityTitle}</p><p class="underline" onclick="window.location='${communityLink}';" aria-label="link to google maps">Get Directions</p></div>`)
      .addTo(map);
  } else {
    
    // Legend Show/Hide Toggle
    $( '.legend-toggle' ).on( 'click', () => {
      $( '.map-section-wrapper' ).toggleClass( 'legend-closed' )
      $( '.hide-show' ).toggleClass( 'hide' )
      setTimeout( () => {
        map.resize();
      }, 300 )
    } )
  
    // Mobile Legend Show/Hide Toggle
    $( '.mobile-toggle, .legend-item' ).on( 'click', (e) => {
      // e.preventDefault();
      $( '.mobile-hide-show' ).toggleClass( 'hide' )
      $( '.points-legend' ).toggleClass( 'mobile-show' )
    } )

    // Amenities Markers
    let amenities = Array.from( document.querySelectorAll( '.amenity-points' ) )

    amenities.sort( ( a, b ) => {
      const aLong = a.dataset.lat
      const bLong = b.dataset.lat
      return bLong - aLong
    } )
    
    amenities.forEach( ( elem, idx ) => {
        let long = elem.dataset.long
        let lat = elem.dataset.lat
        let slug = elem.dataset.slug
        let color = elem.dataset.color
        let type = elem.dataset.type

        let popup = renderPopupContent( elem, map, amenities );

        let el = document.createElement('div');
        el.style.backgroundColor = color;
        el.dataset.slug = slug
        el.dataset.lat = lat
        el.dataset.long = long
        el.className = 'marker amenities-markers';
        el.style.zIndex = idx + 1;
        el.innerHTML = marker_types[type];
        el.style.cursor = "pointer";

        const marker = new mapboxgl.Marker( el )
            .setLngLat( [long, lat] )
            .setPopup(popup)
            .addTo( map );


        // Marker click: toggle/open the matching amenity + accordion and keep everything in sync
        marker.getElement().addEventListener('click', function (e) {
          e.stopPropagation();

          const dataSlug = $( this ).data( 'slug' );
          const $amenity = $( `.amenity[data-slug='${ dataSlug }']` );
          const $accordion = $amenity.closest( '.accordion' );
          const $accordionTitle = $accordion.children( '.title' );
          const isActive = $amenity.hasClass( 'active' );

          // If this amenity is already active, treat marker click as "close"
          if ( isActive ) {
            // Remove all popups via Mapbox API (keeps internal state in sync)
            markers.forEach((m) => {
              const popup = m.getPopup && m.getPopup();
              if (popup) popup.remove();
            });

            // Clear active state
            $amenity.removeClass( 'active' );

            // Close its accordion tab if open
            if ( $accordion.length && $accordion.hasClass( 'open' ) ) {
              $accordionTitle.trigger( 'click' );
            }

            return;
          }

          // Otherwise, open/show this amenity
          markers.forEach((m) => {
            const popup = m.getPopup && m.getPopup();
            if (popup) popup.remove();
          });
          map.flyTo({
            center: [ long, lat ],
            offset: [0, 24],
            essential: true,
            zoom: 13,
            duration: 500,
            curve: 1,
            pitch: 0.05,
          });

          // Ensure the correct accordion section is open
          if ( $accordion.length && !$accordion.hasClass( 'open' ) ) {
            $accordionTitle.trigger( 'click' );
          }

          // Highlight the matching amenity item
          $( amenities ).removeClass( 'active' );
          $amenity.addClass( 'active' );

          // Ensure this marker's popup is visible
          const popup = marker.getPopup && marker.getPopup();
          if (popup) {
            popup.addTo(map);
          }
        });

        markers.push( marker);
        elem.marker = marker;
      });

      // Amenity list click: mirror marker behavior (open/close + highlight)
      $(amenities).on('click', function (e) {
        const $this = $( this );
        const isActive = $this.hasClass( 'active' );
        const $accordion = $this.closest( '.accordion' );
        const $accordionTitle = $accordion.children( '.title' );

        // If this amenity is already highlighted, treat click as "close"
        if ( isActive ) {
          $this.removeClass( 'active' );

          // Remove all popups
          markers.forEach((m) => {
            const popup = m.getPopup && m.getPopup();
            if (popup) popup.remove();
          });

          // Close its accordion tab if open
          if ( $accordion.length && $accordion.hasClass( 'open' ) ) {
            $accordionTitle.trigger( 'click' );
          }

          return;
        }

        // Otherwise, open/show this amenity
        markers.forEach((m) => {
          const popup = m.getPopup && m.getPopup();
          if (popup) popup.remove();
        });

        // Ensure its accordion section is open
        if ( $accordion.length && !$accordion.hasClass( 'open' ) ) {
          $accordionTitle.trigger( 'click' );
        }

        // Highlight this amenity
        $( amenities ).removeClass( 'active' );
        $this.addClass( 'active' );

        map.flyTo({
          center: [ $this.data( 'long' ), $this.data( 'lat' ) + 0.0055 ],
          essential: true,
          zoom: 13,
          duration: 500,
          curve: 1,
          pitch: 0.05,
        });

        setTimeout(() => {
          if (this.marker && this.marker.getPopup) {
            const popup = this.marker.getPopup();
            if (popup) {
              popup.addTo(map);
            }
          }
        }, 500);
      });

      function clearRoute() {
        if ( map.getLayer( 'route' ) ) {
          map.removeLayer( 'route' );
        }
        if ( map.getSource( 'route' ) ) {
          map.removeSource( 'route' );
        }
      }

      //------------------------------------------------------------
      // Sort Buttons
      $( '.sort-legend-button' ).on( 'click', function(e) {
        // e.preventDefault();
        let sortSlug = $( this ).data( 'sort' );

        $( '.legend-container' ).addClass( 'hide' )
        $( `.${sortSlug}-legend` ).removeClass( 'hide' )

        $( '.sort-legend-button' ).removeClass( 'hide' );
        $( this ).addClass( 'hide' );

        $( '.points-title' ).text( sortSlug )

        $( '.map-container .marker' ).addClass( 'hide' )
        $( `.${sortSlug}-markers` ).removeClass( 'hide' )

        $( '.legend-item' ).removeClass( 'active' )

        $( '#interactive-map .mapboxgl-popup' ).remove();

        if ( sortSlug !== 'proximity' ) {
          clearRoute();
        }

        var bounds = new mapboxgl.LngLatBounds();

        if(e.target.classList.contains( 'trail-sort' ) ) {
          return;
        }
        $( markers ).each( function() {
          const marker = this.getElement();
          const coordinates = this.getLngLat();
          if(marker.classList.contains( 'hide' ) ) return;

          bounds.extend( [ coordinates.lng, coordinates.lat ] )
        });

        setTimeout( () => {
          map.fitBounds(bounds, {
            padding: 40
          });
        },500);

        if ( sortSlug === 'proximity' ) {
          getRoute( communityMarker );
        }
      } ) 

      //------------------------------------------------------------
      // Proximity Points
      let proximityPoints = document.querySelectorAll( '.proximity-points' ); 
      proximityPoints.forEach( ( elem ) => {
        let long = elem.dataset.long
        let lat = elem.dataset.lat
        let slug = elem.dataset.slug
     
        let el = document.createElement('div');
     
        el.innerHTML = `<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                               <circle cx="12" cy="16" r="6" fill="${proximityMarkerColor}"/>
                        </svg>`;
     
        el.dataset.slug = slug
        el.dataset.lat = lat
        el.dataset.long = long
        el.className = 'marker proximity-markers hide';
     
        markers.push( new mapboxgl.Marker( el )
          .setLngLat( [long, lat] )
          .addTo( map ));
        })
     
        // create a function to make a directions request
        async function getRoute(end) {
          // make a directions request using cycling profile
          // an arbitrary start will always be the same
          // only the end or destination will change
          const query = await fetch(
            `https://api.mapbox.com/directions/v5/mapbox/driving/${communityMarker[0]},${communityMarker[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
               { method: 'GET' });
          const json = await query.json();
          const data = json.routes[0];
          const route = data.geometry.coordinates;
          const geojson = {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'LineString',
              coordinates: route
            }
          };
     
          const addRouteLayer = () => {
            // if the route already exists on the map, we'll reset it using setData
            if (map.getSource('route')) {
              map.getSource('route').setData(geojson);
            }
            // otherwise, we'll make a new request
            else {
              map.addLayer({
              id: 'route',
              type: 'line',
              source: {
                type: 'geojson',
                data: geojson
              },
              layout: {
                'line-join': 'round',
                'line-cap': 'round'
              },
              paint: {
                'line-color': `${ proximityMarkerColor }`,
                'line-width': 5,
                'line-opacity': 0.75
              }
            });
            }
          };
     
          if (map.isStyleLoaded()) {
            addRouteLayer();
          } else {
            map.once('load', addRouteLayer);
          }
        }

        // Community Marker for Proximity Points
        let comEl = document.createElement('div');
        comEl.innerHTML = `<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="16" r="6" fill="${proximityMarkerColor}"/>
                          </svg>`;
        comEl.className = 'marker proximity-markers hide';

        markers.push( new mapboxgl.Marker( comEl )
            .setLngLat( communityMarker )
            .addTo( map ));

        // Initial layer from data-map on .map-section-wrapper — must run after markers exist (same as sort-legend-button)
        const mapSectionWrapper = document.querySelector( '.map-section-wrapper' )
        const initialMapType = mapSectionWrapper?.dataset?.map
        if ( initialMapType ) {
          document.querySelectorAll( `#${ containerId } .marker` ).forEach( ( el ) => el.classList.add( 'hide' ) )
          document.querySelectorAll( `.${ initialMapType }-markers` ).forEach( ( el ) => el.classList.remove( 'hide' ) )
        }
     
        // Promixity Marker Functions
        $( '.proximity-markers, .proximity-points' ).on( 'click', function(e) {
          e.preventDefault();
          let thisLong = $( this ).data( 'long' )
          let thisLat = $( this ).data( 'lat' )
          let coords = [ thisLong, thisLat ];
          let middle = [ ( ( thisLong + Number( communityLong ) ) / 2 ), ( ( thisLat + Number( communityLat ) ) / 2 ) ]
  
          map.flyTo( {
            center: middle,
            zoom: 10.5,
            duration: 1500
          } )
  
          getRoute(coords);
          $( '.proximity-points' ).removeClass( 'active' )
          $( `.proximity-points[data-slug=${ $( this ).data( 'slug' ) }]` ).addClass( 'active' )
        });
  
        // After style loads: directions when proximity block exists; fit bounds when initial layer
        // matches sort-legend-button (proximity/amenities), so landing on proximity behaves like
        // clicking "Show Proximities"
        const onInteractiveMapReady = () => {
          if ( $( '.proximity-legend' ).length ) {
            getRoute( communityMarker )
          }
          if ( initialMapType && initialMapType !== 'trails' ) {
            const bounds = new mapboxgl.LngLatBounds()
            let hasVisible = false
            $( markers ).each( function() {
              const markerEl = this.getElement()
              if ( markerEl.classList.contains( 'hide' ) ) return
              hasVisible = true
              const coordinates = this.getLngLat()
              bounds.extend( [ coordinates.lng, coordinates.lat ] )
            } )
            if ( hasVisible ) {
              setTimeout( () => {
                map.fitBounds( bounds, { padding: 40 } )
              }, 500 )
            }
          }
        }

        if ( map.isStyleLoaded() ) {
          onInteractiveMapReady()
        } else {
          map.once( 'load', onInteractiveMapReady )
        }


        //------------------------------------------------------------
        // Trails Map
      $( '.trail-points' ).on( 'click', function(e) {
        e.preventDefault();
        console.log(trailObject);
        map.flyTo( trailObject[ $( this ).data( 'trail' ) ] )
      } )

      let trailObject = {}

      const fetchTrailsData = () => {
        fetch( `https://api.mapbox.com/datasets/v1/${ mapboxUser }/${ mapboxTrailsDatasetID }/features?access_token=${ mapboxToken }` )

          .then( function( response ){
            // JSON that is returned from the server must be converted to a JS object asynchronously.
            if ( ! response.ok ) {
              throw new Error( 'Not 200 OK' );
            }
            return response.json();
          } )

          .then(  function( data ) {

            data.features.forEach( ( elem ) => {
              let trailName = elem.properties.trail
              let trailStart = elem.geometry.coordinates[0]
              let trailEnd = elem.geometry.coordinates[ elem.geometry.coordinates.length - 1 ]
              let trailCenter = [ ( ( trailStart[0] + trailEnd[0] ) / 2 ), ( ( trailStart[1] + trailEnd[1] ) / 2 ) ]

              trailObject[ trailName ] = { center: trailCenter, zoom: 16 }
            } )

            return trailObject
          } )

          .catch(  function( err ){
            // An error or `reject` from any of the above `.then()` blocks will end up here.
            console.log( err );
          } );
      }

      fetchTrailsData();
  }
}


function renderPopupContent(elem, map, amenities) { 
  var html = '';
      const href = $( elem ).data( 'directions' );
      if( $( elem ).data( 'amenity_image' ) ) {
        html += `<div class="mapboxgl-popup-content-image"><img src="${ $( elem ).data( 'amenity_image' ) }" alt="${ $( elem ).data( 'title' ) }"></div>`;
      }
      html += `<div class="mapboxgl-popup-content-inner content-info">`;
      html += `<p class="bold">${ $( elem ).data( 'title' ) }</p>`;
      if( $( elem ).data( 'amenity_description' ) ) {
        html += `<p class="mapboxgl-popup-content-description">${ $( elem ).data( 'amenity_description' ) }</p>`;
      }
      html += `<div class="contacts flex" style="justify-content: space-between;">`;
      if( $( elem ).data( 'directions' )) {
        html += `<div class="contact-item flex-aligned" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99105 2L13.9799 9.7047L14.0112 11.0201H9.72036L11.2237 14.2461L11.6309 15.1544L9.81432 16L9.40716 15.0917L7.9038 11.8658L4.89709 15.5302L3.98882 14.528V2.4698L4.99105 2Z" fill="#A28245"></path></svg>
            <a class="underline small" onclick="window.location='${ href }';" target="_blank" rel="noopener noreferrer" aria-label="link out to google maps">Directions</a>
          </div>`;
      }
      // Showhomes specific contact items
      if( $( elem ).data( 'type' ) === 'showhome' ) {
        html += `<div class="contact-item">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.01367 16C6.49805 16 4.20117 14.6875 2.94336 12.5C1.68555 10.3398 1.68555 7.6875 2.94336 5.5C4.20117 3.33984 6.49805 2 9.01367 2C11.502 2 13.7988 3.33984 15.0566 5.5C16.3145 7.6875 16.3145 10.3398 15.0566 12.5C13.7988 14.6875 11.502 16 9.01367 16ZM8.35742 12.0625H9.66992V11.4062V9.65625H11.4199H12.0762V8.34375H11.4199H9.66992V6.59375V5.9375H8.35742V6.59375V8.34375H6.60742H5.95117V9.65625H6.60742H8.35742V11.4062V12.0625Z"/>
          </svg>  
          <a class="underline small" href="${ $( elem ).data( 'builder-website' ) }" target="_blank" rel="noopener noreferrer" aria-label="link out to builder's website">Builder</a>
        </div>`;
        html += `<div class="contact-item">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.01367 16C6.49805 16 4.20117 14.6875 2.94336 12.5C1.68555 10.3398 1.68555 7.6875 2.94336 5.5C4.20117 3.33984 6.49805 2 9.01367 2C11.502 2 13.7988 3.33984 15.0566 5.5C16.3145 7.6875 16.3145 10.3398 15.0566 12.5C13.7988 14.6875 11.502 16 9.01367 16ZM8.35742 12.0625H9.66992V11.4062V9.65625H11.4199H12.0762V8.34375H11.4199H9.66992V6.59375V5.9375H8.35742V6.59375V8.34375H6.60742H5.95117V9.65625H6.60742H8.35742V11.4062V12.0625Z"/>
          </svg>  
          <a class="underline small" href="${ $( elem ).data( 'showhome-link' ) }" target="_blank" rel="noopener noreferrer" aria-label="link out to showhome">Showhome</a>
        </div>`;
      }
      html += `</div>`;

      let popup = new mapboxgl.Popup({ anchor: 'bottom', offset: [ 0, -35 ], maxWidth: '288px' })
        .setLngLat( [ $( elem ).data( 'long' ), $( elem ).data( 'lat' ) ] )
        .setHTML( html );

      // When the popup is closed (close button or map click),
      // un-highlight the amenity and close its accordion tab
      popup.on('close', () => {
        const $amenity = $( elem );
        const $accordion = $amenity.closest( '.accordion' );
        const $accordionTitle = $accordion.children( '.title' );

        $amenity.removeClass( 'active' );

        if ( $accordion.length && $accordion.hasClass( 'open' ) ) {
          $accordionTitle.trigger( 'click' );
        }
      });
      return popup;
}


function renderStaticMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink) {
  renderCommunityMapInstance('static-map', mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, {
    popupCloseButton: false,
  });
}

function renderCommunityMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink) {
  renderCommunityMapInstance('community-map', mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, {
    navigationControl: true,
    popupCloseButton: false,
  });
}

function renderInteractiveMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, proximityMarkerColor, markers, communityLong, communityLat, mapboxUser, mapboxTrailsDatasetID, mapboxTrailsDatasetKey, mapboxToken) { 
  renderCommunityMapInstance('interactive-map', mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, proximityMarkerColor, markers, communityLong, communityLat, mapboxUser, mapboxTrailsDatasetID, mapboxTrailsDatasetKey, mapboxToken, {
    navigationControl: true,
    popupCloseButton: true,
  });
}


// Start here...
$( () => {
  if( typeof mapboxCreds !== 'undefined' && $( '.map' ).length ) { 

       // Mapbox Credentials
       let mapboxToken = mapboxCreds.map_credentials.access_token;
       let mapboxStyleURL = mapboxCreds.map_credentials.map_style_url;
       let mapboxUser = mapboxCreds.map_credentials.account_username;

       mapboxgl.accessToken = mapboxToken;

       let markers = [];
       // Pull Data from PHP ( partials.includes.mapbox-creds )
       // Community Info
       let communityTitle = mapboxCreds.community_location.community_name;
       let communityLong = mapboxCreds.community_location.longitude;
       let communityLat = mapboxCreds.community_location.latitude;
       let communityLink = mapboxCreds.community_location.community_map_link;
       let mapThumbnail = mapboxCreds.community_location.community_thumbnail.url;



        // Mapbox Trails Datasets
        let mapboxTrailsCreated = mapboxCreds.map_credentials.dataset_info.trails_created;
        let mapboxTrailsDatasetID
        let mapboxTrailsDatasetKey

        if( mapboxTrailsCreated ) {
          mapboxTrailsDatasetKey = mapboxCreds.map_credentials.dataset_info.dataset_key;
          mapboxTrailsDatasetID = mapboxCreds.map_credentials.dataset_info.dataset_id;
        }

        // Community Marker
        let communityMarker = [ communityLong, communityLat ]

        let proximityMarkerColor = mapboxCreds.pin_colors.proximity_color;

        renderStaticMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink);
        renderCommunityMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink);
        renderInteractiveMap(mapboxStyleURL, communityMarker, mapThumbnail, communityTitle, communityLink, proximityMarkerColor, markers, communityLong, communityLat, mapboxUser, mapboxTrailsDatasetID, mapboxTrailsDatasetKey, mapboxToken);

  }
} )